<template>
  <v-container fluid id="docForm">
    <v-card>
      <v-toolbar color="secondary" dense flat>
        <v-toolbar-title>Create Transfer Draft (Can be converted to a stock delivery once copied)</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small text to="/transfer-drafts">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="4">
            <div style="font-weight: bold; font-size: 20px; margin-top: 10px">
              From:
              <span class="custom-accent">{{ fromStore && fromStore.Name }}</span>
            </div>
          </v-col>

          <v-col cols="12" xs="12" md="8">
            <span
              style="float: right"
              class="style-18"
              v-if="totalAmount"
            >Total Value: {{ totalAmount.toLocaleString() }}</span>
          </v-col>
        </v-row>
        <v-row dense class="subtitle-2 text--primary">
          <v-col cols="12" xs="12" sm="9" md="9">
            <v-btn text @click.native="transferDialog = true" color="accent" class="mt-1">
              <v-icon left>mdi-plus</v-icon>Add Item To List
            </v-btn>
          </v-col>

          <v-col cols="12" xs="12" sm="3" md="3">
            <span
              v-if="dateReadonly == 'Y' && role != 3"
              style="font-weight: bold; font-size: 16px"
            >Date: {{ date }}</span>
            <DatePicker v-else @date="setDate" :myDate="date" :title="`Date`"></DatePicker>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="12">
            <v-data-table
              :mobile-breakpoint="0"
              light
              dense
              :items-per-page="pageItems"
              :headers="headers"
              :items="transferList"
              item-key="LineNum"
              hide-default-footer
              disable-sort
            >
            <template v-slot:item.index="{ index }">
                <span>{{ index + 1 }}</span>
              </template>

              <!-- selling price template -->
              <template v-slot:item.SellingPrice="{ item }">
                {{
                parseFloat(item.SellingPrice).toLocaleString()
                }}
              </template>
              <!-- end -->
              <!--  quantity template -->
              <template v-slot:item.TransferQty="{ item }">
                <span>{{ parseFloat(item.TransferQty).toLocaleString() }}</span>
              </template>
              <!-- end -->

              <!--  total template -->
              <template v-slot:item.total="{ item }">
                <span>{{ (parseFloat(item.TransferQty) * parseFloat(item.SellingPrice)).toLocaleString() }}</span>
              </template>
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn @click="deleteRow(item)" color="red" icon>
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
          </v-col>

          <v-col cols="12" md="4" class="mt-4">
            <v-autocomplete
              autocomplete="off"
              dense
              outlined
              v-model="selectedCustomer"
              :items="customers"
              label="Transferred To (Customer)"
              item-text="Name"
              item-value="id"
              :search-input.sync="searchCustomers"
              @change="getBranches(selectedCustomer)"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" md="4" class="mt-4">
            <v-autocomplete
              autocomplete="off"
              hide-details
              dense
              outlined
              v-model="store"
              :items="stores"
              label="To Shop / Branch"
              item-text="Name"
              item-value="id"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" md="4" class="mt-4">
            <v-btn small class="float-right" @click="save" :loading="loader" color="primary">
              <v-icon left>mdi-content-save</v-icon>Create Transfer Draft
            </v-btn>
          </v-col>
        </v-row>

        <!-- transfer modal -->
        <v-dialog v-model="transferDialog" max-width="650px">
          <v-card>
            <v-toolbar dense color="secondary" flat>
              <v-toolbar-title>Stock Transfer</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="transferDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid>
                <v-row dense>
                  <v-col cols="12" xs="12" md="12">
                    <v-autocomplete
                      autocomplete="off"
                      v-model="select"
                      :isloading="isLoading"
                      :items="products"
                      :search-input.sync="searchProducts"
                      @change="setTransferItem(select)"
                      :item-text="smsRef == 'pharmacy' ? 'full_name' : 'Name'"
                      item-value="id"
                      cache-items
                      class="mt-2"
                      flat
                      hide-no-data
                      hide-details
                      label="Search Product"
                      outlined
                      dense
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12">
                    <span class="style-18">{{ transferItem.ProductName }}</span>
                  </v-col>

                  <v-col cols="12" xs="12" md="6">
                    <v-text-field
                      autocomplete="off"
                      type="number"
                      v-model="transferItem.AvailableQty"
                      label="Available Qty"
                      outlined
                      dense
                      filled
                      readonly
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" xs="12" md="6">
                    <v-text-field
                      autocomplete="off"
                      type="number"
                      v-model="transferItem.TransferQty"
                      label="Transfer Qty"
                      outlined
                      dense
                      @input="qtyChanged(transferItem)"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="6" xs="6" md="6">
                    <v-text-field
                      autocomplete="off"
                      type="text"
                      name="goodsReceiptUom"
                      filled
                      outlined
                      readonly
                      dense
                      value="Unit(s)"
                      v-if="transferItem.ManualStatus == 'Y'"
                    ></v-text-field>
                    <v-autocomplete
                      autocomplete="off"
                      v-else
                      dense
                      outlined
                      single-line
                      v-model="transferItem.UomEntry"
                      :items="transferItem.ugp1"
                      label="UOM"
                      item-text="UomName"
                      item-value="UomId"
                      @change="uomChanged(transferItem)"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12" xs="12" md="6">
                    <v-text-field
                      filled
                      readonly
                      v-model="transferItem.StockBal"
                      label="Remaining Qty"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" xs="12" md="6" v-show="role == 3">
                    <span class="style-16">Buying Price: {{ transferItem.BuyingPrice }}</span>
                  </v-col>

                  <v-col cols="12" xs="12" md="6" v-show="role == 3">
                    <span class="style-16">Cost Price: {{ transferItem.SellingPrice }}</span>
                  </v-col>

                  <v-col cols="12" xs="12" md="12">
                    <v-text-field v-model="transferItem.ref1" label="Ref No./ IMEI" outlined dense></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-btn color="primary" @click="addRow" :loading="loader">
                      <v-icon left>mdi-plus</v-icon>Add To List
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end of modal -->

        <snackbar ref="snackbar"></snackbar>
      </v-card-text>
    </v-card>
  </v-container>
</template>
    
    <script>
export default {
  components: {},
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    },
    userId() {
      return localStorage.getItem("userId");
    },
    role() {
      return localStorage.getItem("userRole");
    },
    totalAmount() {
      let total = 0;
      if (
        typeof this.transferList != "undefined" &&
        this.transferList.length > 0
      ) {
        return this.transferList
          .map(item => {
            let Qty = 0;
            let SellingPrice = 0;
            if (item.SellingPrice) {
              SellingPrice = item.SellingPrice;
            }
            if (item.TransferQty) {
              Qty = item.TransferQty;
            }
            const amount = Qty * SellingPrice;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    }
  },
  data() {
    return {
      selectedCustomer: null,
      fromStore: {},
      search: null,
      enableCreate: true,
      isLoading: false,
      smsRef: null,
      select: "",
      searchingProduct: false,
      searchProducts: null,
      products: [],
      customers: [],
      userItem: {},
      userDialog: false,
      TransferDeficit: "",
      pageItems: 500,
      loader: false,
      editItem: {},
      damagedItem: {},
      transferItem: {},
      generalSettings: {},
      store: null,
      UserSign2: null,
      stores: [],
      users: [],
      date: new Date().toISOString().substr(0, 10),
      dialog: false,
      damageDialog: false,
      transferDialog: false,
      dateReadonly: "N",
      searchCustomers: null,
      todayDate: new Date().toISOString().substr(0, 10),
      headers: [
        { text: "NO:", value: "index" },
        { text: "Item Code", value: "ItemCode" },
        { text: "Product Name", value: "ProductName" },
        { text: "Transfer Qty", value: "TransferQty" },
        { text: "Unit", value: "uomEntryName" },
        { text: "Cost Price", value: "SellingPrice" },
        { text: "Total", value: "total" },
        { text: "Ref No.", value: "RefNo" },
        { text: "Action", value: "action" }
      ],
      inventory: [],
      transferList: []
    };
  },
  watch: {
    searchProducts(val) {
      if (val && val !== this.select && this.querySelections(val)) {
        this.querySelections(val);
      }
    },
    searchCustomers(val) {
      if (val && val !== this.select && this.queryCustomers(val)) {
        this.queryCustomers(val);
      }
    }
  },
  methods: {
    resetLoader() {
      this.$store.commit("loader", false);
      this.$store.commit("btnLoader", false);
      this.$refs.snackbar.show("Done", "green");
    },
    querySelections(searchText) {
      const self = this;
      const url = "/products/search";

      const data = {
        searchText: searchText
      };
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData.length > 0) {
              self.products = res.ResponseData;
            }
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    queryCustomers(searchText) {
      const self = this;
      const url = "/customers/search";
      const data = {
        searchText: searchText
      };

      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            // if array length > 1
            self.customers = res.ResponseData;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    setDate(date) {
      this.date = date;
    },
    openCreate() {
      this.userDialog = true;
    },
    getBranches(id) {
      const self = this;
      var url = `/stores/customers/${id}`;
      this.$store
        .dispatch("get", url)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    addRow() {
      if (this.transferItem.TransferQty == undefined) {
        this.$refs.snackbar.show(`Please fill the quantity!`, "red");
        return;
      }

      if (this.transferItem.TransferQty > this.transferItem.AvailableQty) {
        this.$refs.snackbar.show(
          `Insufficient Stock Available: ${this.transferItem.AvailableQty}`,
          "red"
        );

        return;
      }

      // check if item already exists
      const exists = this.transferList.find(record => {
        return record.productId === this.transferItem.productId;
      });

      if (exists) {
        this.$refs.snackbar.show(`Item already exists in the list!`, "red");
        return;
      }

      let initArray = [];
      initArray.push(this.transferItem);
      this.transferList = [...this.transferList, ...initArray];
      this.transferItem = {};
      this.select = "";
      this.products = [];
      this.transferDialog = false;
    },
    uomChanged(data) {
      const self = this;

      // get converted qty
      let details = {
        productId: parseInt(data.productId),
        quantity: parseFloat(data.TransferQty),
        uomEntry: parseInt(data.UomEntry)
      };

      let uomEntryName = "";

      // uom name
      let ugp1 = data.ugp1;
      let ugp1Record = {};
      if (data.ManualStatus == "N") {
        ugp1Record = ugp1.find(record => {
          return record.UomId === data.UomEntry;
        });
        uomEntryName = ugp1Record.UomName;
      } else {
        uomEntryName = "Pcs";
      }
      // end

      const url = `/converted-qty`;

      // self.$store.commit("loader", true);
      this.$store
        .dispatch("post", { url, data: details })
        .then(res => {
          if (res.ResultCode == 1200) {
            const StockBalance = data.AvailableQty - res.ResponseData;
            self.transferItem = {
              ...self.transferItem,
              BuyingPrice: ugp1Record.BuyingPrice,
              SellingPrice: ugp1Record.SellingPrice,
              StockBal: StockBalance,
              uomEntryName: uomEntryName
            };
            // self.$store.commit("loader", false);
          } else {
            // self.$store.commit("loader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("loader", false);
          this.$refs.snackbar.show(err, "red");
        });

      if (!data.TransferQty) {
        this.$refs.snackbar.show("Please fill the quantity!", "red");
      }
    },
    qtyChanged(data) {
      const self = this;
      const available = data.AvailableQty;
      if (data.TransferQty) {
        // get converted qty
        let details = {
          productId: parseInt(data.productId),
          quantity: parseFloat(data.TransferQty),
          uomEntry: data.UomEntry ? parseInt(data.UomEntry) : 0
        };
        const url = `/converted-qty`;
        this.$store
          .dispatch("post", { url, data: details })
          .then(res => {
            if (res.ResultCode == 1200) {
              const StockBalance = available - res.ResponseData;
              self.transferItem = {
                ...self.transferItem,
                StockBal: StockBalance
              };
            } else {
              this.$refs.snackbar.show(res.ResultDesc, "red");
            }
          })
          .catch(err => {
            self.$store.commit("loader", false);
            this.$refs.snackbar.show(err, "red");
          });
      } else {
        self.transferItem = {
          ...self.transferItem,
          StockBal: available
        };
      }
    },
    deleteRow(item) {
      const selectedRow = this.transferList.find(record => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.transferList.indexOf(selectedRow);
      if (pos === -1) {
        return;
      }
      this.transferList.splice(pos, 1);
    },
    setTransferItem(id) {
      const self = this;
      var storeId = this.fromStore.id;
      // fetch the product from database
      this.$store
        .dispatch("get", `/product-inventory/${id}/${storeId}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            const product = res.ResponseData;

            let currentItem = {};
            const LineNum = new Date().getTime();
            currentItem.refNo = "";
            currentItem.LineNum = LineNum;
            currentItem.Quantity = null;
            currentItem.ManualStatus = product.HasUom == 0 ? "Y" : "N";
            currentItem.productId = id;
            currentItem.ItemCode = product.ItemCode;
            currentItem.ProductName = product.Name;
            currentItem.AvailableQty = product.AvailableQty;
            currentItem.StockBal = product.AvailableQty;
            // end

            if (product.HasUom === 0) {
              // check if manual yes and assign
              var sellingPrice = product.sellingPrice;
              var buyingPrice = product.buyingPrice;
              currentItem.BuyingPrice = buyingPrice;
              currentItem.SellingPrice = sellingPrice;
              currentItem.currentPrice = sellingPrice;
              currentItem.uomEntryName = "Pc(s)";
              currentItem.UomEntry = 0;
              // end of manual yes
            }

            // start of manual No status
            if (product.HasUom === 1) {
              let ugp1Data = product.ugp1;
              const ugp1Record = ugp1Data.find(record => {
                return record.UomEntry === product.SUoMEntry;
              });
              currentItem.ugp1 = product.ugp1;
              currentItem.UomEntry = product.SUoMEntry;
              currentItem.uomEntryName = ugp1Record.UomName;
              currentItem.BuyingPrice = ugp1Record.BuyingPrice;
              currentItem.SellingPrice = ugp1Record.SellingPrice;
            }

            self.transferItem = { ...self.transferItem, ...currentItem };

            this.select = null;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
      // end of fetch
    },
    save() {
      if (this.store == this.activeStore) {
        this.$refs.snackbar.show(
          "You cannot transfer to the same store!",
          "red"
        );
        return;
      }

      if (this.date == null || this.date == undefined) {
        this.$refs.snackbar.show("Please select date!", "red");
        return;
      }

      if (this.store == null) {
        this.$refs.snackbar.show("Please select store ! ", "red");
        return;
      }

      if (this.transferList.length <= 0) {
        this.$refs.snackbar.show(
          "You must add at least one item to transer!",
          "red"
        );
      }

      const data = {};
      data.FromStoreId = parseInt(this.fromStore.id);
      data.ToStoreId = parseInt(this.store);
      data.CustomerId = parseInt(this.selectedCustomer) ?? 0;
      data.DocDate = this.date;

      var rows = [];
      for (const item of this.transferList) {
        var details = {
          productId: parseInt(item.productId),
          quantity: parseFloat(item.TransferQty),
          uomEntry: parseInt(item.UomEntry),
          buyingPrice: parseFloat(item.BuyingPrice),
          sellingPrice: parseFloat(item.SellingPrice),
          refNo: item.refNo
        };

        rows.push(details);
      }

      data.rows = rows;
      data.DocTotal = parseFloat(this.totalAmount);

      const url = `/stock-transfer-drafts`;
      const self = this;
      // self.loader = true;

      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.$router.push("/transfer-drafts");
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.loader = false;
          this.$refs.snackbar.show(err, "red");
        });
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/stores`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getUsers() {
      const self = this;
      this.$store
        .dispatch("get", `/users`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.users = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getDefaultWarehouse() {
      const self = this;
      this.$store
        .dispatch("get", `/default-warehouse`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.fromStore = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGenSettings() {
      const self = this;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("get", `/general-settings`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.TransferDeficit = res.ResponseData.TransferDeficit;
            self.dateReadonly = res.ResponseData.dateReadonly;
            self.smsRef = res.ResponseData.smsRef;
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    Promise.all([
      this.getStores(),
      this.getUsers(),
      this.getDefaultWarehouse()
      //  this.getGenSettings()
    ]);
  }
};
</script>
    
    <style lang="scss" scoped>
</style>